class LWDiv extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    static get observedAttributes() {
        return ['bg-color', 'bg-img', 'gradient', 'opacity', 'padding'];
    }

    connectedCallback() { this.render(); }
    attributeChangedCallback() { this.render(); }

   render() {
    const bgColor = this.getAttribute('bg-color') || 'transparent';
    const bgImg = this.getAttribute('bg-img') || '';
    const gradient = this.getAttribute('gradient') || '';
    const opacity = this.getAttribute('opacity') || '1';
    const padding = this.getAttribute('padding') || '80px 80px'; // Iets minder breed voor de zekerheid

    let backgroundStyle = `background-color: ${bgColor};`;
    
    if (gradient) {
        const colors = gradient.split(',').map(c => c.trim());
        backgroundStyle = `background: linear-gradient(to bottom, ${colors[0]} 0%, ${colors[1]} 30%, ${colors[2]} 100%);`;
    }
    
    if (bgImg) {
        backgroundStyle = `background-image: url('${bgImg}'); background-size: cover; background-position: center;`;
    }

    this.shadowRoot.innerHTML = /* html */ `
    <style>
        :host {
            display: block;
            width: 100%;
            height: 100%; /* Belangrijk: neem de hoogte van de panel over */
        }
        .content-wrapper {
            width: 100%;
            min-height: 100%; /* Niet vh, maar % */
            padding: 30px 30px;
            box-sizing: border-box;
            ${backgroundStyle}
            opacity: ${opacity};
            display: flex;
            flex-direction: column;
        }

        @media (min-width: 600px) {
            .content-wrapper {
                width: 100%;
                min-height: 100%; /* Niet vh, maar % */
                padding: 80px 80px;
                box-sizing: border-box;
                ${backgroundStyle}
                opacity: ${opacity};
                display: flex;
                flex-direction: column;
            }
        }
    </style>
    <div class="content-wrapper">
        <slot></slot>
    </div>
    `;
}
}
customElements.define('lw-div', LWDiv);